import Vue from 'vue';
import VueRouter from 'vue-router';
import Indicator from '../components/Indicator';
import Store from '@/utils/Store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home'),
    meta: {
      title: '形白定制',
      keepAlive: true
    }
  },
  {
    path: '/createCard',
    name: 'createCard',
    component: () => import('@/views/createCard'),
    meta: {
      title: '形白定制',
      keepAlive: true
    }
  },
  {
    path: '/selectCard',
    name: 'selectCard',
    component: () => import('@/views/selectCard'),
    meta: {
      title: '选择尺寸规格',
      keepAlive: true
    }
  },
  {
    path: '/customCard',
    name: 'customCard',
    component: () => import('@/views/customCard'),
    meta: {
      title: '自定义规格'
    }
  },
  {
    path: '/cardDetail',
    name: 'cardDetail',
    component: () => import('@/views/cardDetail'),
    meta: {
      title: ''
    }
  },
  {
    path: '/orderCheck',
    name: 'orderCheck',
    component: () => import('@/views/orderCheck'),
    meta: {
      title: '购买并校验订单'
    }
  },
  {
    path: '/saveImage',
    name: 'saveImage',
    component: () => import('@/views/saveImage'),
    meta: {
      title: ''
    }
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () => import('@/views/orderDetail'),
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/skuDetail',
    name: 'skuDetail',
    component: () => import('@/views/skuDetail'),
    meta: {
      title: '证件照冲印'
    }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test'),
    meta: {
      title: ''
    }
  },
  {
    path: '/addPhoto',
    name: 'addPhoto',
    component: () => import('@/views/addPhoto'),
    meta: {
      title: '添加照片',
      keepAlive: true
    }
  },
  {
    path: '/editLifePhoto',
    name: 'editLifePhoto',
    component: () => import('@/views/editLifePhoto'),
    meta: {
      title: '编辑',
      keepAlive: true
    }
  },
  {
    path: '/editPld',
    name: 'editPld',
    component: () => import('@/views/editPld'),
    meta: {
      title: '编辑',
      keepAlive: true
    }
  },
  {
    path: '/editNameSticker',
    name: 'editNameSticker',
    component: () => import('@/views/editNameSticker'),
    meta: {
      title: '编辑',
      keepAlive: true
    }
  },
  {
    path: '/selectTemplate',
    name: 'selectTemplate',
    component: () => import('@/views/selectTemplate'),
    meta: {
      title: '选择模板',
      keepAlive: true
    }
  },
  {
    path: '/selectLifeTemplate',
    name: 'selectLifeTemplate',
    component: () => import('@/views/selectLifeTemplate'),
    meta: {
      title: '选择模板',
      keepAlive: true
    }
  },
  {
    path: '/editPb',
    name: 'editPb',
    component: () => import('@/views/editPb'),
    meta: {
      title: '编辑',
      keepAlive: true
    }
  },
  {
    path: '/editLifePb',
    name: 'editLifePb',
    component: () => import('@/views/editLifePb'),
    meta: {
      title: '编辑',
      keepAlive: true
    }
  },
  {
    path: '/fullscreen',
    name: 'fullscreen',
    component: () => import('@/views/fullscreen'),
    meta: {
      title: '编辑',
      keepAlive: true
    }
  },
  {
    path: '/pbDetail',
    name: 'pbDetail',
    component: () => import('@/views/pbDetail'),
    meta: {
      title: '拼版冲印'
    }
  },
  {
    path: '/finish',
    name: 'finish',
    component: () => import('@/views/finish'),
    meta: {
      title: '上传成功'
    }
  },
  {
    path: '/editPaster',
    name: 'editPaster',
    component: () => import('@/views/editPaster'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/edit',
    name: 'edit',
    component: () => import('@/views/edit'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/selectImage',
    name: 'selectImage',
    component: () => import('@/views/selectImage'),
    meta: {
      title: '编辑照片顺序'
    }
  },
  {
    path: '/editPhotoRoll',
    name: 'editPhotoRoll',
    component: () => import('@/views/editPhotoRoll'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/photoRollTemplate',
    name: 'photoRollTemplate',
    component: () => import('@/views/photoRollTemplate'),
    meta: {
      title: '选择模板'
    }
  },
  {
    path: '/photoRollDetail',
    name: 'photoRollDetail',
    component: () => import('@/views/photoRollDetail'),
    meta: {
      title: '选择模板'
    }
  },
  {
    path: '/retouch',
    name: 'retouch',
    component: () => import('@/views/retouch'),
    meta: {
      title: '手动抠图'
    }
  },
  {
    path: '/customSize',
    name: 'customSize',
    component: () => import('@/views/customSize'),
    meta: {
      title: '自定义规格'
    }
  },
  {
    path: '/editCustomSize',
    name: 'editCustomSize',
    component: () => import('@/views/editCustomSize'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/changeHole',
    name: 'changeHole',
    component: () => import('@/views/changeHole'),
    meta: {
      title: '改孔位'
    }
  },
  {
    path: '/changeKeyHole',
    name: 'changeKeyHole',
    component: () => import('@/views/changeKeyHole'),
    meta: {
      title: '改孔位'
    }
  },
  {
    path: '/changeSocket',
    name: 'changeSocket',
    component: () => import('@/views/changeSocket'),
    meta: {
      title: '移动插口'
    }
  },
  {
    path: '/editImage',
    name: 'editImage',
    component: () => import('@/views/editImage'),
    meta: {
      title: '编辑图片'
    }
  },
  {
    path: '/editImageNew',
    name: 'editImageNew',
    component: () => import('@/views/editImageNew'),
    meta: {
      title: '编辑图片'
    }
  },
  {
    path: '/background',
    name: 'background',
    component: () => import('@/views/background'),
    meta: {
      title: '背景页面'
    }
  },
  {
    path: '/editBackground',
    name: 'editBackground',
    component: () => import('@/views/editBackground'),
    meta: {
      title: '编辑背景'
    }
  },
  {
    path: '/editWhiteInk',
    name: 'editWhiteInk',
    component: () => import('@/views/editWhiteInk'),
    meta: {
      title: '编辑白墨'
    }
  },
  {
    path: '/editWhiteInkNew',
    name: 'editWhiteInkNew',
    component: () => import('@/views/editWhiteInkNew'),
    meta: {
      title: '编辑白墨'
    }
  },
  {
    path: '/previewColorPaper',
    name: 'previewColorPaper',
    component: () => import('@/views/previewColorPaper'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/previewColorPaperNew',
    name: 'previewColorPaperNew',
    component: () => import('@/views/previewColorPaperNew'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/editColorPaper',
    name: 'editColorPaper',
    component: () => import('@/views/editColorPaper'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/',
    name: 'debug',
    component: () => import('@/views/debug'),
    meta: {
      title: '形白定制'
    }
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('@/views/demo'),
    meta: {
      title: 'demo'
    }
  },
  {
    path: '/changeOutline',
    name: 'changeOutline',
    component: () => import('@/views/changeOutline'),
    meta: {
      title: '描边'
    }
  }
];

const router = new VueRouter({
  mode: 'hash', // history
  routes
});

import * as mwx from '@/utils/common.js';

// 设置一个存储上次导航时间的变量
let lastGoBackTime = 0;
// 设置一个最短允许的间隔（例如500毫秒）
const minNavigationInterval = 500; // 单位为毫秒

router.beforeEach((to, from, next) => {
  if (to.query.shopId) {
    Store.set('shopId', to.query.shopId);
  }
  const now = Date.now();
  // mwx.log.info(
  //   `beforeEach:to=${to.fullPath},from=${from.fullPath},time=${
  //     now - lastGoBackTime
  //   },to.name=${to.name}`
  // );
  Indicator.close();
  try {
    // 如果距离上次导航不足最小间隔，则阻止这次导航
    // console.log('now - lastGoBackTime', now - lastGoBackTime);
    // 限制以下路由短时间内导航多次
    if (
      now - lastGoBackTime < minNavigationInterval &&
      ['home', 'orderDetail', 'addPhoto'].indexOf(to.name) > -1
    ) {
      mwx.log.info('Too fast! Navigation blocked.');
      return next(false); // 阻止导航
    }

    // 更新最后一次导航时间
    lastGoBackTime = now;
    if (from.fullPath == '/') {
      // 刷新页面导致的重定向是允许多时间内导航多次的
      lastGoBackTime = 0;
    }
  } catch (error) {
    // console.error(error);
    // 处理错误
  }
  if (from.path == '/') {
    // 中间过程流程的页面手动刷新之后，需要回到首页
    let token = mwx.getToken();
    //

    // 检查是否是返回操作

    let mustLogin = true;
    // mustLogin = false;
    let notLoginWhiteList = ['retouch', 'test', 'background', 'demo'];

    let isFromMiniApp =
      location.href.indexOf('wxData') > -1 &&
      location.href.indexOf('token') > -1;
    if (isFromMiniApp) {
      mustLogin = false;
    }

    if (
      (['createCard', 'saveImage'].indexOf(to.name) > -1 ||
        (!token && to.name != 'home')) &&
      mustLogin &&
      notLoginWhiteList.indexOf(to.name) == -1
    ) {
      if (!token && to.name != 'home' && to.query.soId) {
        let deviceId = Store.get('deviceId');
        if (!deviceId) {
          deviceId = mwx.createId(32);
          Store.set('deviceId', deviceId);
        }
        mwx.api
          .siteVisitorLogin({ deviceId, soId: to.query.soId })
          .then((r) => {
            mwx.setToken(r.token);
            next();
            window.report &&
              window.report('error', {
                reason: 'router location.reload1'
              });
            location.href = location.origin;
          })
          .catch((err) => {
            next(false);
            window.report &&
              window.report('error', {
                reason: 'router location.reload2'
              });
            location.href = location.origin;
          });
        return;
      }
      mwx.log.error(
        `重定向到首页,to=${JSON.stringify(to)},from=${JSON.stringify(from)}`
      );
      next(false);
      window.report &&
        window.report('error', {
          reason: 'router location.reload3'
        });
      location.href = location.origin;

      return;
    } else {
      next();
    }
  } else {
    next();
  }
});

// keep-alive缓存的路由列表
const keepAliveRouteList = [
  'createCard',
  'saveImage',
  'selectCard',
  'addPhoto',
  'selectTemplate',
  'editPaster',
  'edit',
  'editPhotoRoll',
  'editWhiteInk',
  'editWhiteInkNew',
  'editColorPaper'
];

function getKeepAliveRouteList({ to, from }) {
  let includeList;
  if (to.name == 'cardDetail' && from.name == 'createCard') {
    includeList = [
      'cardDetail',
      ...keepAliveRouteList.filter((v) => v !== 'createCard')
    ];
  } else {
    includeList = ['cardDetail', ...keepAliveRouteList];
  }
  if (to.name == 'editPaster' && from.name == 'editWhiteInk') {
    // 不缓存
    includeList = includeList.filter((v) => v != 'editWhiteInk');
  }
  if (to.name == 'edit' && from.name == 'editWhiteInkNew') {
    // 不缓存
    includeList = includeList.filter((v) => v != 'editWhiteInkNew');
  }
  return includeList;
}

export { router, keepAliveRouteList, getKeepAliveRouteList };
